import ChangeEntityVisibilityContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ChangeEntityVisibilityContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import InternalStakeholdersModel from "../model/InternalStakeholdersModel";

export default class InternalStakeholderAvailabilityCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(dispatcher, internalStakeholdersModel) {
        super(dispatcher);

        this._internalStakeholdersModel = internalStakeholdersModel;
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {ChangeEntityVisibilityContent} */
        const content = data.content;
        /** @type {NGTScenarioPlayer} */
        const contentPlayer = data.contentPlayer;

        const internalStakeholderId = content.getEntityID();
        const activateInternalStakeholder = content.getVisible();

        const internalStakeholder = this._internalStakeholdersModel.getInternalStakeholderById(internalStakeholderId);
        if (activateInternalStakeholder) {
            this._internalStakeholdersModel.activateInternalStakeholder(internalStakeholder);
        } else {
            this._internalStakeholdersModel.deactivateInternalStakeholder(internalStakeholder);
        }

        contentPlayer.contentCompleted(content);
    }
}